import { css } from '@emotion/react';
import colors from '../../../Themes/colors';
import fonts from '../../../Themes/fonts';

export const orderReviewSectionTitleContainer = css({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '80px',
});

export const tableHeaderOverwrite = css({
    fontSize: '14px',

    '@media(min-width:992px)': {
        fontSize: '16px',
    },
});

export const orderReviewSectionTitle = css({
    font: '40px Playfair',
    color: colors.black,
    fontWeight: '700',
});

export const orderReviewSection = css({
    margin: '15px 0px',

    '@media(min-width:576px)': {
        margin: '15px 0px',
    },
});

export const orderReviewTitle = css({
    font: '14px Acumin VF',
    color: '#616161',
    fontWeight: '500',
    marginBottom: '8px',
});

export const orderReviewText = css({
    font: '16px Acumin VF',
    color: colors.black,
    fontWeight: '500',
});

export const orderReviewEditText = css({
    font: '18px Archivo-Regular, sans-serif',
    color: '#064E72',
    marginRight: '5px',
});

export const placeOrderButton = css({
    font: '18px Archivo-Regular, sans-serif',
    color: colors.white,
    backgroundColor: colors.primary,
    border: `2px solid ${colors.primary}`,
    borderRadius: '3px',
    padding: '12px',
    width: '100%',
    transition: 'ease 0.2s',
    '&:hover': {
        backgroundColor: colors.white,
        border: `2px solid ${colors.primary}`,
        color: colors.primary,
    },
    '&:focus': {
        backgroundColor: colors.primary,
        border: `2px solid ${colors.primary}`,
        color: colors.white,
    },
});

export const placeOrderInfo = css({
    font: '14px Archivo-Regular, sans-serif',
    color: colors.gray,
    marginTop: '1.2em',
});
